import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

/**
 * Reusable confirmation dialog for deleting a user.
 * @param {{open?: boolean, user?: any, onClose?: (...args: any[]) => void, onConfirm?: (user: any)=>void}} props
 */
export default function UserDeleteDialog({ open = false, user = null, onClose, onConfirm }) {
  const handleConfirm = () => {
    onConfirm && onConfirm(user);
  };

  return (
    <Dialog open={!!open} onClose={onClose} disableScrollLock>
      <DialogTitle>Delete user</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete {user?.firstName || ''} {user?.lastName || ''}? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} color="error" variant="contained">Delete</Button>
      </DialogActions>
    </Dialog>
  );
}
